import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CoreService } from './core.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(
    private http: HttpClient,
    private coreService: CoreService,
  ) {}

  getFirstApiData(): Observable<any> {
    return this.coreService.getRequest(`ApplicationSetting/ServerTime`);
  }
}
